/**
 * @generated SignedSource<<be61f7457d3cd17d02006c8dc8d469ea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewLayoutSingleSelectUserPickerField_IssueViewSingleSelectUserPickerField$data = {
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"issueViewReporterField_servicedeskCustomerServiceCustomFields_JCSReporterFieldInner" | "ui_issueViewLayoutAssigneeField_IssueViewAssigneeField" | "ui_issueViewLayoutReporterField_IssueViewReporterField" | "ui_issueViewLayoutUserField_IssueViewUserField">;
  readonly " $fragmentType": "ui_issueViewLayoutSingleSelectUserPickerField_IssueViewSingleSelectUserPickerField";
};
export type ui_issueViewLayoutSingleSelectUserPickerField_IssueViewSingleSelectUserPickerField$key = {
  readonly " $data"?: ui_issueViewLayoutSingleSelectUserPickerField_IssueViewSingleSelectUserPickerField$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutSingleSelectUserPickerField_IssueViewSingleSelectUserPickerField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "jcsFlag"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueViewLayoutSingleSelectUserPickerField_IssueViewSingleSelectUserPickerField",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsassigneerelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutAssigneeField_IssueViewAssigneeField"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsreporterrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutReporterField_IssueViewReporterField"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldsuserrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutUserField_IssueViewUserField"
        }
      ]
    },
    {
      "condition": "jcsFlag",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "issueViewReporterField_servicedeskCustomerServiceCustomFields_JCSReporterFieldInner"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "type"
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};

(node as any).hash = "0e7c9532d2cad44df2707353aba9b7f0";

export default node;
